module.exports = __webpack_public_path__ + "img/manage_your_money.63a6ec86.jpg";